import { render } from "./AddContent.vue?vue&type=template&id=ebdaf0e8&ts=true"
import script from "./AddContent.vue?vue&type=script&lang=ts"
export * from "./AddContent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__